import React, { useEffect, useRef, useState } from "react";
import { UserSearch, X } from "lucide-react";
import { api } from "../lib/api";
import { bn, tk } from "../lib/format";
import { useDebounced } from "./ProductSearch";

export default function CustomerPicker({ value, onSelect, onTypeName, placeholder = "ক্রেতার নাম / মোবাইল দিয়ে খুঁজুন", testid = "memo-customer-select" }: any) {
  const [q, setQ] = useState("");
  const [list, setList] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const dq = useDebounced(q);
  const box = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    api.get("/customers", { params: { q: dq } }).then((r) => setList(r.data.slice(0, 8))).catch(() => null);
  }, [dq, open]);

  useEffect(() => {
    const h = (e: MouseEvent) => { if (box.current && !box.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  if (value) {
    return (
      <div className="flex items-center justify-between gap-3 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2" data-testid="selected-customer">
        <div>
          <p className="font-semibold text-slate-900">{value.name}</p>
          <p className="text-xs text-slate-600">{value.mobile ? bn(value.mobile) : "মোবাইল নেই"} · বাকি: <b className={value.due > 0 ? "text-red-600" : "text-emerald-700"}>{tk(value.due)}</b></p>
        </div>
        <button type="button" onClick={() => onSelect(null)} className="w-8 h-8 grid place-items-center rounded-lg hover:bg-white" data-testid="clear-customer-button" aria-label="মুছুন">
          <X size={16} />
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={box}>
      <UserSearch size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <input className="inp pl-10" value={q} placeholder={placeholder} data-testid={testid}
        onChange={(e) => { setQ(e.target.value); setOpen(true); onTypeName?.(e.target.value); }} onFocus={() => setOpen(true)} />
      {open && list.length > 0 && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-xl shadow-xl overflow-hidden" data-testid="customer-search-results">
          {list.map((c, i) => (
            <button type="button" key={c.id} onMouseDown={(e) => { e.preventDefault(); onSelect(c); setQ(""); setOpen(false); }}
              className="w-full text-left px-4 py-2.5 flex justify-between gap-3 hover:bg-blue-50" data-testid={`customer-search-result-${i}`}>
              <span>
                <span className="font-semibold">{c.name}</span>
                <span className="block text-xs text-slate-500">{c.mobile ? bn(c.mobile) : ""} {c.address}</span>
              </span>
              <span className={`num text-sm font-semibold ${c.due > 0 ? "text-red-600" : "text-emerald-700"}`}>{tk(c.due)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
